(function() {
var AlphaOMSUtils,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

AlphaOMSUtils = (function() {
  var get_url_separator, visit;

  function AlphaOMSUtils() {
    this.on_click_submit_form = bind(this.on_click_submit_form, this);
    this.monitor_background_progress_tasks = bind(this.monitor_background_progress_tasks, this);
    this.on_input_data_mass_assignment = bind(this.on_input_data_mass_assignment, this);
    this.on_change_auto_save = bind(this.on_change_auto_save, this);
    this.on_keyup_auto_save = bind(this.on_keyup_auto_save, this);
    this.on_click_row_submit = bind(this.on_click_row_submit, this);
    this.submit_nested_embedded_form = bind(this.submit_nested_embedded_form, this);
    this.disable_form = bind(this.disable_form, this);
    this.on_form_submit_turn_off_disabled = bind(this.on_form_submit_turn_off_disabled, this);
    this.on_keyup_search = bind(this.on_keyup_search, this);
    this.on_keyup_calculate_tax = bind(this.on_keyup_calculate_tax, this);
    this.on_keyup_total_up_inputs = bind(this.on_keyup_total_up_inputs, this);
    this.close_popover_remotes = bind(this.close_popover_remotes, this);
    this.on_click_popover_remote = bind(this.on_click_popover_remote, this);
    this.on_click_clear_loading = bind(this.on_click_clear_loading, this);
    this.on_click_show_loading = bind(this.on_click_show_loading, this);
    this.on_click_checkbox_unchecked_submit = bind(this.on_click_checkbox_unchecked_submit, this);
    this.on_click_checkbox_checked_submit = bind(this.on_click_checkbox_checked_submit, this);
    this.on_click_row_select_checkbox = bind(this.on_click_row_select_checkbox, this);
    this.init_table_with_row_select = bind(this.init_table_with_row_select, this);
    this.on_click_sum_table_checkbox = bind(this.on_click_sum_table_checkbox, this);
    this.on_click_scroll_to = bind(this.on_click_scroll_to, this);
    this.on_click_copy = bind(this.on_click_copy, this);
    this.on_change_set_target_value = bind(this.on_change_set_target_value, this);
    this.on_click_set_input = bind(this.on_click_set_input, this);
    this.on_click_clear_input = bind(this.on_click_clear_input, this);
    this.on_click_close_bs2_modal = bind(this.on_click_close_bs2_modal, this);
    this.on_click_disable = bind(this.on_click_disable, this);
    this.on_click_enable = bind(this.on_click_enable, this);
    this.on_click_text = bind(this.on_click_text, this);
    this.on_click_hide = bind(this.on_click_hide, this);
    this.on_click_toggle_disable = bind(this.on_click_toggle_disable, this);
    this.on_click_toggle = bind(this.on_click_toggle, this);
    this.on_click_toggle_input = bind(this.on_click_toggle_input, this);
    this.toggle_class = bind(this.toggle_class, this);
    this.on_click_prevent_default = bind(this.on_click_prevent_default, this);
    this.on_click_show = bind(this.on_click_show, this);
    this.on_click_empty = bind(this.on_click_empty, this);
    this.on_click_remove = bind(this.on_click_remove, this);
    this.on_tab_select = bind(this.on_tab_select, this);
    this.on_click_swatch = bind(this.on_click_swatch, this);
    this.radio_buttons_change = bind(this.radio_buttons_change, this);
    this.on_change_get_url = bind(this.on_change_get_url, this);
    this.refresh_progress_element = bind(this.refresh_progress_element, this);
    this.on_change_opacity = bind(this.on_change_opacity, this);
    this.on_change_submit_partial = bind(this.on_change_submit_partial, this);
    this.on_change_form_partial = bind(this.on_change_form_partial, this);
    this.on_click_submit_to = bind(this.on_click_submit_to, this);
    this.on_change_form_rehydrate = bind(this.on_change_form_rehydrate, this);
    this.select_option_show_fields = bind(this.select_option_show_fields, this);
    this.checkbox_hide_fields = bind(this.checkbox_hide_fields, this);
    this.checkbox_show_fields = bind(this.checkbox_show_fields, this);
    this.clicked_radio_button_container = bind(this.clicked_radio_button_container, this);
    this.clicked_on_data_link_remote = bind(this.clicked_on_data_link_remote, this);
    this.clicked_on_data_link = bind(this.clicked_on_data_link, this);
    this.clicked_on_select_link = bind(this.clicked_on_select_link, this);
    this.last_progress_update_timestamp = Date.now();
    this.last_autosave_timestamp = Date.now();
    this.final_autosave_timeout = null;
  }

  AlphaOMSUtils.prototype.is_input = function(elem) {
    return elem.is("input,select,textarea");
  };

  AlphaOMSUtils.prototype.init_switches = function() {
    var ref;
    if ($.fn.bootstrapSwitch != null) {
      $('input.switch').bootstrapSwitch();
    }
    return (ref = window.alpha_oms) != null ? typeof ref.init_bootstrap_toggles === "function" ? ref.init_bootstrap_toggles() : void 0 : void 0;
  };

  AlphaOMSUtils.prototype.disable_switches = function($scope) {
    if ($.fn.bootstrapSwitch != null) {
      $scope.find('input.switch').bootstrapSwitch('disabled', true);
    }
    return $scope.find('input[type=checkbox][data-toggle="toggle"]').each(function(index, elem) {
      if (elem.bootstrapToggle != null) {
        return elem.bootstrapToggle('disable');
      }
    });
  };

  AlphaOMSUtils.prototype.reload = function(selector, callback) {
    if (callback == null) {
      callback = null;
    }
    return $(selector).each(function(index, elem) {
      var _url;
      _url = $(elem).attr("data-url");
      if (_url != null) {
        _url = _url + get_url_separator(_url) + "reload=1";
        console.log("reload called for url: " + _url);
        return $.ajax({
          type: 'GET',
          url: _url,
          data: null,
          dataType: 'html',
          success: function(data) {
            $(elem).replaceWith(data);
            window.alpha_oms_utils.init_switches();
            if (callback) {
              return callback.call();
            }
          },
          error: function(error) {
            console.log(error);
            return alert("there was an error reloading the data");
          }
        });
      }
    });
  };

  AlphaOMSUtils.prototype.reload_datatables = function() {
    return $('table.dataTable').each(function() {
      return $(this).DataTable().ajax.reload();
    });
  };

  AlphaOMSUtils.prototype.clicked_on_select_link = function(event) {
    var $elem, id, url, value;
    $elem = $(event.target);
    url = $elem.data("url");
    id = $elem.prop("id");
    value = $elem.val();
    return visit(url, id + "=" + value);
  };

  AlphaOMSUtils.prototype.clicked_on_data_link = function(event) {
    var $target, url;
    $target = $(event.target);
    if ($target.closest("a, button, input, select, textarea, label").length > 0) {
      return;
    }
    if ($target.hasClass("unclickable")) {
      return;
    }
    url = $target.closest("[data-at-link]").data("at-link");
    if (!url) {
      return;
    }
    return Turbo.visit(url);
  };

  AlphaOMSUtils.prototype.clicked_on_data_link_remote = function(event) {
    var success_callback, url;
    url = $(event.target).closest("[data-at-link-remote]").data("at-link-remote");
    success_callback = function(response) {};
    return $.get(url, {}, success_callback).fail(function() {
      return alert("There was an error loading the resource");
    });
  };

  AlphaOMSUtils.prototype.clicked_radio_button_container = function(event) {
    var $radio_button, $radio_button_container, _is_input, _target;
    console.log("clicked radio button container");
    _target = $(event.target);
    _is_input = _target.prop("nodeName") === "INPUT";
    if (!_is_input) {
      $radio_button_container = _target.closest("[data-radio-button-container]");
      $radio_button_container.addClass("selected_icon");
      $radio_button = $radio_button_container.find("input[type='radio']").first();
      $radio_button.click();
      return $radio_button.trigger("at:radio-click");
    }
  };

  AlphaOMSUtils.prototype.submit_form = function(id, filter_params, black_list_params, url, ajax_method) {
    var $elem, _filter, _filter_string, _form_data, _name, _pair, _query_string, _serialized_data, _value, disable_submit_buttons, form_data, j, k, l, len, len1, len2, param, ref, ref1, ref2;
    if (filter_params == null) {
      filter_params = [];
    }
    if (black_list_params == null) {
      black_list_params = [];
    }
    if (url == null) {
      url = "";
    }
    if (ajax_method == null) {
      ajax_method = "";
    }
    $elem = $("#" + id);
    if ($elem.length === 0) {
      $elem = $("form[data-url]");
    }
    if (url === "") {
      url = $elem.data("url");
    }
    if (ajax_method === "") {
      ajax_method = $elem.data("ajax-method") || "GET";
    }
    disable_submit_buttons = true;
    if ($elem.data("ajax-no-disable")) {
      disable_submit_buttons = false;
    }
    _form_data = form_data = $elem.find("input, select, textarea");
    if (filter_params.length > 0) {
      _filter = [];
      for (j = 0, len = filter_params.length; j < len; j++) {
        param = filter_params[j];
        _filter.push("[name='" + param + "']");
      }
      _filter = _filter.join(",");
      _form_data = form_data.filter(_filter);
    } else if (black_list_params.length > 0) {
      _filter = [];
      for (k = 0, len1 = black_list_params.length; k < len1; k++) {
        param = black_list_params[k];
        _filter.push("[name='" + param + "']");
      }
      _filter_string = _filter.join(",");
      _filter = ":not(" + _filter_string + ")";
      _form_data = form_data.filter(_filter);
    }
    if (disable_submit_buttons) {
      $elem.find("[type='submit']").prop("disabled", true);
    }
    _serialized_data = _form_data.serializeArray();
    _serialized_data.push({
      name: "_method",
      value: ajax_method
    });
    if (ajax_method.toUpperCase() === "GET" && url.indexOf("?") >= 0) {
      ref = url.split("?"), url = ref[0], _query_string = ref[1];
      ref1 = _query_string.split("&");
      for (l = 0, len2 = ref1.length; l < len2; l++) {
        _pair = ref1[l];
        if (!(_pair)) {
          continue;
        }
        ref2 = _pair.split("="), _name = ref2[0], _value = ref2[1];
        _serialized_data.push({
          name: decodeURIComponent(_name),
          value: decodeURIComponent(_value || "")
        });
      }
    }
    return $.ajax({
      type: "POST",
      url: url,
      data: _serialized_data,
      headers: {
        'Oms-Form-Submit': true
      },
      dataType: "script"
    }).done(function() {
      $('#spinner, #spinner_nav').hide();
      return window.alpha_oms_utils.init_switches();
    }).fail(function() {
      if (disable_submit_buttons) {
        return $elem.find("[type='submit']").prop("disabled", false);
      }
    });
  };

  AlphaOMSUtils.prototype.switch_show_fields = function(event, state) {
    var $elem, $fields_elem, _selector, checked;
    $elem = $(event.target);
    checked = state === true;
    _selector = $elem.data("switch-show-fields");
    $fields_elem = $(_selector);
    if (checked) {
      return $fields_elem.fadeIn('fast');
    } else {
      $fields_elem.find("input.switch").prop("checked", false).trigger("change.bootstrapSwitch");
      if (!$elem.data("switch-show-fields-do-not-clear")) {
        $fields_elem.find("input.string").val("");
      }
      return $fields_elem.fadeOut('fast');
    }
  };

  AlphaOMSUtils.prototype.switch_hide_fields = function(event, state) {
    var $elem, $fields_elem, _selector, checked;
    $elem = $(event.target);
    checked = state === true;
    _selector = $elem.data("switch-hide-fields");
    $fields_elem = $(_selector);
    if (checked) {
      return $fields_elem.fadeOut('fast');
    } else {
      $fields_elem.find("input.switch").prop("checked", false).trigger("change.bootstrapSwitch");
      if (!$elem.data("switch-hide-fields-do-not-clear")) {
        $fields_elem.find("input.string").val("");
      }
      return $fields_elem.fadeIn('fast');
    }
  };

  AlphaOMSUtils.prototype.hide_fields_when_on = function(event, state) {
    var $elem, $fields_elem, _selector, checked;
    $elem = $(event.target);
    checked = state === true;
    _selector = $elem.data("hide-fields-when-on");
    $fields_elem = $(_selector);
    if (checked) {
      $fields_elem.find("input.switch").prop("checked", false).trigger("change.bootstrapSwitch");
      $fields_elem.find("input.string").val("");
      return $fields_elem.fadeOut('fast');
    }
  };

  AlphaOMSUtils.prototype.show_fields_when_on = function(event, state) {
    var $elem, $fields_elem, _selector, checked;
    $elem = $(event.target);
    checked = state === true;
    _selector = $elem.data("show-fields-when-on");
    $fields_elem = $(_selector);
    if (checked) {
      return $fields_elem.fadeIn('fast');
    }
  };

  AlphaOMSUtils.prototype.switch_secondary_show_field = function(event, state) {
    var $child_elem, $elem, $parent_elem, _child, _parent, checked;
    $elem = $(event.target);
    checked = state === true;
    _parent = $elem.data("switch-secondary-show-field-parent");
    $parent_elem = $(_parent);
    _child = $elem.data("switch-secondary-show-field-child");
    $child_elem = $(_child);
    if (checked) {
      $parent_elem.attr('data-switch-show-fields', $elem.data("switch-secondary-show-field-child"));
      if ($parent_elem.prop('checked')) {
        $child_elem.find("input.switch").prop("checked", false).trigger("change.bootstrapSwitch");
        return $child_elem.fadeIn('fast');
      }
    } else {
      $parent_elem.removeAttr('data-switch-show-fields');
      if ($child_elem.is(':visible')) {
        $child_elem.find("input.switch").prop("checked", false).trigger("change.bootstrapSwitch");
        return $child_elem.fadeOut('fast');
      }
    }
  };

  AlphaOMSUtils.prototype.toggle_all_check_boxes = function(event) {
    var $elem, $table, _render_row_select, _sum_table_elem, _target_selector, checked, hide_on_unchecked;
    $elem = $(event.target);
    _target_selector = $elem.data("checkbox-toggle-all");
    $table = $elem.closest("table");
    checked = $elem.prop("checked");
    $table.find(_target_selector).prop("checked", checked);
    hide_on_unchecked = true;
    if ($elem.data("checkbox-toggle-all-row-select-no-hide-on-unchecked")) {
      hide_on_unchecked = false;
    }
    _sum_table_elem = $elem.closest("[data-sum-table]");
    if (_sum_table_elem.length > 0) {
      this.recalculate_table_sum(_sum_table_elem);
    }
    _render_row_select = $elem.data("checkbox-toggle-all-row-select");
    if (_render_row_select) {
      this.render_row_select_row($table.find("tbody tr"), checked, hide_on_unchecked);
      return this.render_row_select_table_button($table);
    }
  };

  AlphaOMSUtils.prototype.checkbox_show_fields = function(event) {
    var $elem, $fields_elem, checked, fields_id;
    $elem = $(event.target);
    checked = $elem.prop("checked");
    fields_id = $elem.data("checkbox-show-fields");
    $fields_elem = $("#" + fields_id);
    if (checked) {
      return $fields_elem.fadeIn('fast').addClass("showing");
    } else {
      $fields_elem.find("input.boolean").prop("checked", false).trigger("change");
      $fields_elem.find("input.string").val("");
      return $fields_elem.fadeOut('fast', "swing", function() {
        return $fields_elem.removeClass("showing");
      });
    }
  };

  AlphaOMSUtils.prototype.checkbox_hide_fields = function(event) {
    var $elem, $fields_elem, checked, fields_id;
    $elem = $(event.target);
    checked = $elem.prop("checked");
    fields_id = $elem.data("checkbox-hide-fields");
    $fields_elem = $("#" + fields_id);
    if (checked) {
      $fields_elem.find("input.boolean").prop("checked", false).trigger("change");
      $fields_elem.find("input.string").val("");
      return $fields_elem.fadeOut('fast', "swing", function() {
        return $fields_elem.removeClass("showing");
      });
    } else {
      return $fields_elem.fadeIn('fast').addClass("showing");
    }
  };

  AlphaOMSUtils.prototype.select_option_show_fields = function(event) {
    var $elem, $elems, _not_selected_fields, _show_fields_selector;
    $elem = $(event.target);
    _show_fields_selector = $elem.find(":selected").data("option-show-fields");
    _not_selected_fields = $elem.find("option[data-option-show-fields]:not(:selected)");
    if (_not_selected_fields.length > 0) {
      _not_selected_fields.each(function(i, elem) {
        var $not_selected_elem, $other_fields_elems, _fields_selector;
        $not_selected_elem = $(elem);
        _fields_selector = $not_selected_elem.data("option-show-fields");
        if (_fields_selector !== _show_fields_selector) {
          $other_fields_elems = $("" + _fields_selector);
          $other_fields_elems.find("input.boolean").prop("checked", false).trigger("change");
          $other_fields_elems.find("input.string").val("");
          return $other_fields_elems.hide();
        }
      });
    }
    if (_show_fields_selector) {
      $elems = $("" + _show_fields_selector);
      return $elems.fadeIn('fast').addClass("showing");
    }
  };

  AlphaOMSUtils.prototype.on_change_form_rehydrate = function(event) {
    var $elem, $form, _black_list_params, _black_params, _disable_form_section, _elem_id, _form_id, _show_loader, _white_list_params, _white_params;
    $elem = $(event.target);
    $form = $elem.closest("form");
    _form_id = $form.attr("id");
    _white_list_params = [];
    _white_params = $elem.data("on-change-form-rehydrate-params");
    if (_white_params && _white_params.length > 0) {
      _white_list_params = _white_params.split(",");
    }
    _black_list_params = [];
    _black_params = $elem.data("on-change-form-rehydrate-ignore-params");
    if (_black_params && _black_params.length > 0) {
      _black_list_params = _black_params.split(",");
    }
    _show_loader = $elem.data("on-change-form-rehydrate-show-loader");
    _disable_form_section = $elem.data("on-change-form-rehydrate-disable-form-section");
    if (_form_id) {
      if ($form.find("#form_rehydrate_loader").length > 0) {
        this.show_spinner("#form_rehydrate_loader");
      } else if (_show_loader) {
        _elem_id = $elem.attr("id");
        this.show_spinner("#" + _elem_id, 10, 20);
        if (_disable_form_section) {
          $(_disable_form_section).find("input").prop("readonly", "readonly");
        }
      }
      return this.submit_form(_form_id, _white_list_params, _black_list_params);
    }
  };

  AlphaOMSUtils.prototype.on_click_submit_to = function(event) {
    var ajax_method, elem, form, form_data, url;
    elem = $(event.target);
    form = elem.closest("form");
    url = elem.data("on-click-submit-to");
    ajax_method = elem.data("ajax-method") || "POST";
    form_data = form.find("input, select, textarea, button").serializeArray();
    if (elem.is("button,input[type=submit]") && elem.attr("name")) {
      form_data.push({
        name: elem.attr("name"),
        value: elem.val()
      });
    }
    return $.ajax({
      type: ajax_method,
      url: url,
      data: form_data,
      headers: {
        'Oms-Form-Submit': true
      },
      dataType: "script"
    }).done(function() {
      return window.alpha_oms_utils.init_switches();
    });
  };

  AlphaOMSUtils.prototype.on_change_form_partial = function(event) {
    var $elem, $partial_elem, _elem_id, disable_elem, form_data, param, partial_id, url, value;
    $elem = $(event.target);
    _elem_id = $elem.attr("id");
    partial_id = $elem.data("on-change-form-partial");
    $partial_elem = $("#" + partial_id);
    param = $elem.data("on-change-param");
    url = $partial_elem.data("url");
    this.show_spinner("#" + _elem_id, 10, 10);
    if (param) {
      value = $elem.val();
      form_data = param + "=" + value;
    } else {
      form_data = $partial_elem.find("input, select").serialize();
    }
    disable_elem = $elem.data("on-change-disable");
    if (disable_elem) {
      $("" + disable_elem).addClass("disabled");
      $(disable_elem + " input").prop("disabled", true);
      $(disable_elem + " a.btn, " + disable_elem + " button").addClass("disabled");
    }
    return $.ajax({
      url: "" + url + (get_url_separator(url)) + form_data,
      dataType: "html"
    }).success(function(html) {
      return $partial_elem.replaceWith(html);
    }).error(function() {
      return alert("There was an error");
    }).done(function() {
      return $('#spinner, #spinner_nav').hide();
    });
  };

  AlphaOMSUtils.prototype.on_change_submit_partial = function(event) {
    var $elem, $partial_elem, form_data;
    $elem = $(event.target);
    $partial_elem = $elem.closest("[data-on-change-partial-to-submit]");
    form_data = $partial_elem.find("input, select");
    return $.ajax({
      type: $partial_elem.data("ajax-method") || "GET",
      url: $partial_elem.data("on-change-partial-to-submit"),
      data: form_data.serialize(),
      headers: {
        'Oms-Form-Submit': true
      },
      dataType: "script"
    }).done(function() {
      $('#spinner, #spinner_nav').hide();
      return window.alpha_oms_utils.init_switches();
    });
  };

  AlphaOMSUtils.prototype.on_change_opacity = function(event) {
    var $elem, opacity, selector;
    $elem = $(event.target);
    selector = $elem.data("on-change-opacity");
    opacity = $elem.data("on-change-opacity-amount");
    return $(selector).css("opacity", opacity);
  };

  AlphaOMSUtils.prototype.refresh_progress_element = function(refresh_progress_elem, data_payload) {
    var _time_diff, _time_now, _url;
    _time_now = Date.now();
    _time_diff = _time_now - this.last_progress_update_timestamp;
    if (_time_diff > 1500) {
      this.last_progress_update_timestamp = _time_now;
      if (data_payload.progress_refresh_complete) {
        if (typeof _url !== "undefined" && _url !== null) {
          return Turbo.visit(_url);
        }
      } else {
        _url = refresh_progress_elem.data("progress-refresh-url");
        return $.ajax({
          url: _url,
          dataType: "html"
        }).success(function(html) {
          return refresh_progress_elem.replaceWith(html);
        }).error(function() {
          return console.log("There was an error");
        });
      }
    }
  };

  AlphaOMSUtils.prototype.on_change_get_url = function(event) {
    var $elem, _elem_id, clear_elem, disable_elem, param, url, value;
    $elem = $(event.target);
    url = $elem.data("on-change-get-url");
    param = $elem.data("on-change-param");
    value = $elem.val();
    clear_elem = $elem.data("on-change-clear");
    if (clear_elem) {
      $("" + clear_elem).empty();
    }
    disable_elem = $elem.data("on-change-disable");
    if (disable_elem) {
      $("" + disable_elem).addClass("disabled");
      $(disable_elem + " input").prop("disabled", true);
      $(disable_elem + " a.btn, " + disable_elem + " button").addClass("disabled");
    }
    _elem_id = $elem.attr("id");
    this.show_spinner("#" + _elem_id, 10, 10);
    return Turbo.visit("" + url + (get_url_separator(url)) + param + "=" + value);
  };

  AlphaOMSUtils.prototype.radio_buttons_change = function(event) {
    var $elem, $wrapper_elem, selector;
    $elem = $(event.target);
    $wrapper_elem = $elem.closest("[data-at-radio-buttons]");
    $wrapper_elem.find('label').each(function(i, elem) {
      return $(elem).removeClass("btn-primary");
    });
    $elem.addClass("btn-primary");
    $wrapper_elem.find('[data-at-radio-buttons-show]').each(function(i, elem) {
      return $($(elem).data("at-radio-buttons-show")).hide();
    });
    selector = $elem.data("at-radio-buttons-show");
    if (selector) {
      return $(selector).show();
    }
  };

  AlphaOMSUtils.prototype.on_click_swatch = function(event) {
    var $elem, $input_field, $swatch_wrapper, swatch_input_field_name, swatch_val;
    $elem = $(event.target).closest("[data-at-swatch]");
    swatch_val = $elem.data("at-swatch");
    $swatch_wrapper = $elem.closest("[data-swatch-input]");
    swatch_input_field_name = $swatch_wrapper.data("swatch-input");
    console.log("on click swatch: " + swatch_input_field_name + ", val: " + swatch_val);
    $input_field = $("form input[name='" + swatch_input_field_name + "']");
    $input_field.val(swatch_val);
    $swatch_wrapper.find("[data-at-swatch]").removeClass("swatch-active");
    return $elem.addClass("swatch-active");
  };

  AlphaOMSUtils.prototype.on_tab_select = function(event) {
    var $elem, $li_elem, $ul_elem, $update_elem, _tab_name, _update_id;
    $elem = $(event.target);
    $li_elem = $elem.closest("li");
    $ul_elem = $li_elem.closest("ul[data-tab-update]");
    _tab_name = $li_elem.data("tab");
    _update_id = $ul_elem.data("tab-update");
    return $update_elem = $("#" + _update_id).val(_tab_name);
  };

  AlphaOMSUtils.prototype.on_click_remove = function(event) {
    var $elem, _fade_out, _selector;
    $elem = $(event.target).closest("[data-on-click-remove]");
    _selector = $elem.data("on-click-remove");
    _fade_out = $elem.data("on-click-remove-transition");
    if (_fade_out && _fade_out === "fade_out") {
      return $(_selector).fadeOut("fast", function() {
        return $(this).remove();
      });
    } else {
      return $(_selector).remove();
    }
  };

  AlphaOMSUtils.prototype.on_click_empty = function(event) {
    var $elem, _fade_out, _selector;
    $elem = $(event.target).closest("[data-on-click-empty]");
    _selector = $elem.data("on-click-empty");
    _fade_out = $elem.data("on-click-empty-transition");
    if (_fade_out && _fade_out === "fade_out") {
      return $(_selector).fadeOut("fast", function() {
        return $(this).empty();
      });
    } else {
      return $(_selector).empty();
    }
  };

  AlphaOMSUtils.prototype.on_click_show = function(event) {
    var $elem, _to_show_selector;
    $elem = $(event.target).closest("[data-on-click-show]");
    _to_show_selector = $elem.data("on-click-show");
    return $(_to_show_selector).show();
  };

  AlphaOMSUtils.prototype.on_click_prevent_default = function(event) {
    return event.preventDefault();
  };

  AlphaOMSUtils.prototype.toggle_class = function(elem, checked, class_name) {
    if (checked) {
      return elem.addClass(class_name);
    } else {
      return elem.removeClass(class_name);
    }
  };

  AlphaOMSUtils.prototype.on_click_toggle_input = function(event) {
    var $name, $toggle_elem, $trigger_elem, $wrapper_elem, _active_class, _to_toggle_selector, checked;
    $trigger_elem = $(event.target);
    $wrapper_elem = $trigger_elem.closest("[data-on-click-toggle-input]");
    _active_class = $wrapper_elem.data("on-click-toggle-input-active-class");
    if ($trigger_elem.is('input[type="checkbox"], input[type="radio"]')) {
      if (_active_class) {
        this.toggle_class($wrapper_elem, $trigger_elem.is(':checked'), _active_class);
      }
      return;
    }
    _to_toggle_selector = $wrapper_elem.data("on-click-toggle-input");
    $toggle_elem = $(_to_toggle_selector);
    if ($toggle_elem.attr('type') === 'radio') {
      $name = $toggle_elem.attr('name');
      $("input[type='radio'][name='" + $name + "']").prop("checked", false);
      return $toggle_elem.prop("checked", true).trigger("change");
    } else {
      checked = $toggle_elem.prop("checked");
      if (_active_class) {
        this.toggle_class($wrapper_elem, !checked, _active_class);
      }
      return $toggle_elem.prop("checked", !checked).trigger("change");
    }
  };

  AlphaOMSUtils.prototype.on_click_toggle = function(event) {
    var $elem, $reverse_toggle_elements, $toggle_elem, _off_text, _on_text, _to_toggle_selector, reverse_toggle_selector;
    $elem = $(event.target).closest("[data-on-click-toggle-visibility]");
    _to_toggle_selector = $elem.data("on-click-toggle-visibility");
    _on_text = $elem.data("on-click-toggle-on-text");
    _off_text = $elem.data("on-click-toggle-off-text");
    reverse_toggle_selector = $elem.data("on-click-reverse-toggle");
    $toggle_elem = $(_to_toggle_selector);
    if (reverse_toggle_selector) {
      $reverse_toggle_elements = $(reverse_toggle_selector);
    }
    if ($toggle_elem.is(":visible")) {
      if (_on_text) {
        $elem.text(_on_text);
      }
      $toggle_elem.hide();
      if (reverse_toggle_selector) {
        return $reverse_toggle_elements.show();
      }
    } else {
      if (_off_text) {
        $elem.text(_off_text);
      }
      $toggle_elem.show();
      if (reverse_toggle_selector) {
        return $reverse_toggle_elements.hide();
      }
    }
  };

  AlphaOMSUtils.prototype.on_click_toggle_disable = function(event) {
    var $elem, $toggle_elem, _to_toggle_selector;
    $elem = $(event.target).closest("[data-on-click-toggle-disabled]");
    _to_toggle_selector = $elem.data("on-click-toggle-disabled");
    $toggle_elem = $(_to_toggle_selector);
    if ($toggle_elem.hasClass("disabled")) {
      $toggle_elem.removeClass("disabled");
      if (!this.is_input($toggle_elem)) {
        return $toggle_elem.find("input,select,textarea").prop("disabled", false).removeClass("disabled");
      }
    } else {
      $toggle_elem.addClass("disabled");
      if (!this.is_input($toggle_elem)) {
        return $toggle_elem.find("input,select,textarea").prop("disabled", true).addClass("disabled");
      }
    }
  };

  AlphaOMSUtils.prototype.on_click_hide = function(event) {
    var $elem, _to_hide_selector;
    $elem = $(event.target).closest("[data-on-click-hide]");
    _to_hide_selector = $elem.data("on-click-hide");
    return $(_to_hide_selector).hide();
  };

  AlphaOMSUtils.prototype.on_click_text = function(event) {
    var $elem, _text;
    $elem = $(event.target).closest("[data-on-click-text]");
    _text = $elem.data("on-click-text");
    if ($elem.is("input")) {
      return $elem.val(_text);
    } else {
      return $elem.text(_text);
    }
  };

  AlphaOMSUtils.prototype.on_click_enable = function(event) {
    var $elem;
    $elem = $(event.target).closest("[data-on-click-enable]");
    return $elem.removeClass("disabled");
  };

  AlphaOMSUtils.prototype.on_click_disable = function(event) {
    var $elem;
    $elem = $(event.target).closest("[data-on-click-disable]");
    $elem.addClass("disabled");
    if ($elem.is("a")) {
      return $elem.attr("href", "javascript:void(0)");
    }
  };

  AlphaOMSUtils.prototype.on_click_close_bs2_modal = function(event) {
    return this.close_bs2_modal();
  };

  AlphaOMSUtils.prototype.on_click_clear_input = function(event) {
    var $elem, _to_clear_input_selector;
    $elem = $(event.target).closest("[data-on-click-clear-input]");
    _to_clear_input_selector = $elem.data("on-click-clear-input");
    $(_to_clear_input_selector).val("");
    return $(_to_clear_input_selector).trigger("change");
  };

  AlphaOMSUtils.prototype.on_click_set_input = function(event) {
    var $elem;
    $elem = $(event.target).closest("[data-on-click-set-input]");
    return $($elem.data("on-click-set-input")).val($elem.data("on-click-set-input-val"));
  };

  AlphaOMSUtils.prototype.on_change_set_target_value = function(event) {
    var $source_elem, _label, _target_selector;
    event.preventDefault();
    $source_elem = $(event.target);
    _label = $source_elem.find("option:selected").text();
    _target_selector = $source_elem.data("on-change-set-target-value");
    return $(_target_selector).val(_label);
  };

  AlphaOMSUtils.prototype.on_click_copy = function(event) {
    var $copy_elem, _source_selector, _target_selector, _value;
    event.preventDefault();
    $copy_elem = $(event.target);
    _value = $copy_elem.data("on-click-copy-value");
    _source_selector = $copy_elem.data("on-click-copy-source");
    _target_selector = $copy_elem.data("on-click-copy-target");
    if (_source_selector) {
      _value = $(_source_selector).val();
    }
    return $(_target_selector).val(_value);
  };

  AlphaOMSUtils.prototype.on_click_scroll_to = function(event) {
    var _speed, _target_selector;
    event.preventDefault();
    _target_selector = $(event.target).data("on-click-scroll-to");
    _speed = $(event.target).data("on-click-scroll-to-speed") || 100;
    return this.scroll_to_element(_target_selector, _speed);
  };

  AlphaOMSUtils.prototype.on_click_sum_table_checkbox = function(event) {
    var $sum_table_elem;
    $sum_table_elem = $(event.target).closest("[data-sum-table]");
    return this.recalculate_table_sum($sum_table_elem);
  };

  AlphaOMSUtils.prototype.recalculate_table_sum = function(sum_table_elem) {
    var $total_elem, _init_val_string, _sum_total, _total_selector, _total_value_as_money;
    _total_selector = sum_table_elem.data("sum-table-total-element");
    $total_elem = $(_total_selector);
    _sum_total = 0;
    _init_val_string = sum_table_elem.data("sum-table");
    if (_init_val_string != null) {
      _sum_total = parseInt(_init_val_string, 10);
    }
    sum_table_elem.find("input[data-sum-table-checkbox]:checked").each(function(i, elem) {
      var _pence;
      _pence = parseInt($(elem).data("sum-table-checkbox"), 10);
      return _sum_total += _pence;
    });
    _total_value_as_money = (_sum_total / 100.0).toFixed(2);
    if ($total_elem.is("input")) {
      return $total_elem.val(_total_value_as_money);
    } else {
      return $total_elem.text(_total_value_as_money);
    }
  };

  AlphaOMSUtils.prototype.init_table_with_row_select = function() {
    this.render_row_select_table_button($("table[data-row-select]"));
    return $("table[data-row-select] td input[type='checkbox'][data-row-select-checkbox]:checked").closest("tr").find("td input:not([data-row-select-checkbox],[type='hidden']), td select").prop("disabled", false);
  };

  AlphaOMSUtils.prototype.on_click_row_select_checkbox = function(event) {
    var $checkbox, $row, $table, _checked, hide_on_unchecked;
    $checkbox = $(event.target);
    $row = $checkbox.closest("tr");
    $table = $row.closest("table[data-row-select]");
    hide_on_unchecked = true;
    if ($table.data("row-select-no-hide-on-unchecked")) {
      hide_on_unchecked = false;
    }
    if ($row) {
      _checked = $checkbox.prop("checked");
      this.render_row_select_row($row, _checked, hide_on_unchecked);
    }
    if ($table) {
      return this.render_row_select_table_button($table);
    }
  };

  AlphaOMSUtils.prototype.render_row_select_row = function(row, checked, hide_on_unchecked) {
    var $row_inputs;
    $row_inputs = row.find("td input:not([data-row-select-checkbox],[type='hidden']), td select");
    if (checked) {
      $row_inputs.prop("disabled", false);
      return $row_inputs.show();
    } else {
      $row_inputs.prop("disabled", true);
      if (hide_on_unchecked) {
        return $row_inputs.hide();
      }
    }
  };

  AlphaOMSUtils.prototype.render_row_select_table_button = function(table) {
    var _selector;
    _selector = table.data("row-select");
    if (_selector) {
      if (table.find("tbody input[type='checkbox'][data-row-select-checkbox]:checked").length > 0) {
        return $(_selector).prop("disabled", false);
      } else {
        return $(_selector).prop("disabled", true);
      }
    }
  };

  AlphaOMSUtils.prototype.on_click_row_select_trigger_checkbox = function(event) {
    var _selector;
    _selector = $(event.target).closest("tr").data("row-select-trigger-checkbox");
    if (_selector) {
      return $(_selector).trigger("click");
    }
  };

  AlphaOMSUtils.prototype.on_click_checkbox_checked_submit = function(event) {
    var $elem, url;
    $elem = $(event.target);
    if ($elem.prop("checked")) {
      url = $elem.data("checkbox-checked-submit-url");
      return $.ajax({
        type: "post",
        url: url,
        headers: {},
        dataType: "script"
      });
    }
  };

  AlphaOMSUtils.prototype.on_click_checkbox_unchecked_submit = function(event) {
    var $elem, url;
    $elem = $(event.target);
    if (!$elem.prop("checked")) {
      url = $elem.data("checkbox-unchecked-submit-url");
      return $.ajax({
        type: "delete",
        url: url,
        headers: {},
        dataType: "script"
      });
    }
  };

  AlphaOMSUtils.prototype.on_click_show_loading = function(event) {
    var $elem, original_text;
    console.log("on_click_show_loading");
    $elem = $(event.target);
    original_text = $elem.text();
    $elem.data("loading-text-original", original_text);
    return $elem.addClass("disabled").text($elem.data('loading-text') || "Loading...");
  };

  AlphaOMSUtils.prototype.on_click_clear_loading = function(event) {
    var $elem, $target_elem, loading_text_original, target_selector;
    $elem = $(event.target);
    target_selector = $elem.data("on-click-clear-loading");
    if (target_selector != null) {
      $target_elem = $(target_selector);
      $target_elem.removeClass("disabled");
      loading_text_original = $target_elem.data("loading-text-original");
      if (loading_text_original != null) {
        return $target_elem.text(loading_text_original);
      }
    }
  };

  AlphaOMSUtils.prototype.on_click_popover_remote = function(event) {
    var $button, anchor_left, extra_class, href;
    event.preventDefault();
    $button = $(event.target).closest("[data-popover-remote]");
    $button.popover('destroy');
    href = $button.attr("href");
    anchor_left = $button.data("popover-anchor-left");
    extra_class = $button.data("popover-remote-class") || "";
    return $.ajax({
      url: href,
      method: 'GET',
      success: function(data) {
        var $popover, $popover_arrow, anchor_offset, arrow_left, button_center, button_offset, popover_arrow_offset, popover_offset;
        $button.popover({
          html: true,
          trigger: 'manual',
          content: data,
          placement: 'bottom',
          template: "<div class=\"popover at-popover-remote " + extra_class + "\" role=\"tooltip\">\n  <div class=\"arrow\"></div>\n  <div class=\"popover-content\"></div>\n</div>"
        });
        $button.popover('show');
        $popover = $('.at-popover-remote');
        $popover_arrow = $popover.find(".arrow");
        if (anchor_left != null) {
          anchor_offset = $(anchor_left).offset();
          popover_offset = $popover.offset();
          button_offset = $button.offset();
          popover_arrow_offset = $popover_arrow.offset();
          $popover.css({
            top: $popover.offset().top - 10,
            left: anchor_offset.left
          });
          popover_offset = $popover.offset();
          button_center = button_offset.left + ($button.outerWidth() / 2);
          arrow_left = button_center - popover_offset.left;
          return $popover_arrow.css({
            left: arrow_left + "px"
          });
        }
      },
      error: function() {
        return alert('Failed to load content. Please try again later.');
      }
    });
  };

  AlphaOMSUtils.prototype.close_popover_remotes = function(e) {
    var $button, $popover;
    $popover = $(document).find(".at-popover-remote");
    $button = $(document).find("[data-popover-remote]");
    if ($popover.length > 0 && !this.is_within_bounds(e, $popover)) {
      return $button.popover('hide');
    }
  };

  AlphaOMSUtils.prototype.is_within_bounds = function(event, $elem) {
    var cx, cy, rect;
    cx = event.clientX;
    cy = event.clientY;
    rect = $elem[0].getBoundingClientRect();
    if (cx === 0 && cy === 0) {
      return true;
    }
    return cx >= rect.left && cx <= rect.right && cy >= rect.top && cy <= rect.bottom;
  };

  AlphaOMSUtils.prototype.recalculate_invoice_item_costs = function(event) {
    var $tr_tag, qty, tax_cost, tax_cost_pence, tax_rate, total_invoice_item_cost, total_invoice_item_cost_pence, total_unit_cost_pence, tr_tag, unit_cost, unit_cost_pence;
    tr_tag = $(event.target).closest("tr");
    $tr_tag = $(tr_tag);
    unit_cost = Number($tr_tag.find("td.unit_cost input").val());
    qty = Number($tr_tag.find("td.qty input").val());
    tax_rate = Number($tr_tag.find("td.tax_rate input").val());
    unit_cost_pence = Math.round(unit_cost * 100);
    tax_cost_pence = Math.round(unit_cost_pence * (tax_rate / 100.0));
    total_unit_cost_pence = unit_cost_pence + tax_cost_pence;
    total_invoice_item_cost_pence = total_unit_cost_pence * qty;
    tax_cost = tax_cost_pence / 100.0;
    total_invoice_item_cost = total_invoice_item_cost_pence / 100.0;
    $tr_tag.find("td.tax_cost input").val(tax_cost.toFixed(2));
    return $tr_tag.find("td.total_cost input").val(total_invoice_item_cost.toFixed(2));
  };

  AlphaOMSUtils.prototype.on_keyup_total_up_inputs = function(event) {
    var $elem, _total, _total_show_elem_id, _total_text, _total_value_elem_id;
    $elem = $(event.target).closest("[data-total-up-inputs]");
    _total_show_elem_id = $elem.data("total-up-inputs-show");
    _total_value_elem_id = $elem.data("total-up-inputs-value");
    _total = 0;
    $elem.find("input[data-total-up-input]").each(function(i, elem) {
      var _float_val, _integer_val, _val;
      _val = $(elem).val();
      if (_val !== "") {
        _float_val = Number.parseFloat(_val);
        _integer_val = _float_val * 100;
        return _total += _integer_val;
      }
    });
    _total_text = (_total / 100.0).toFixed(2);
    $(_total_show_elem_id).text(_total_text);
    return $(_total_value_elem_id).val(_total_text);
  };

  AlphaOMSUtils.prototype.on_keyup_calculate_tax = function(event) {
    var $elem, _divide, _ex_tax_amount, _ex_tax_amount_selector, _tax_amount, _tax_amount_selector, _tax_rate, _value;
    $elem = $(event.target).closest("[data-calculate-tax]");
    _tax_amount_selector = $elem.data("tax-field");
    _ex_tax_amount_selector = $elem.data("ex-tax-field");
    _tax_rate = Number($elem.data("tax-rate"));
    _value = Number($elem.val());
    _divide = 1 + (_tax_rate / 100.0);
    _ex_tax_amount = _value / _divide;
    _tax_amount = _value - _ex_tax_amount;
    if (_tax_amount_selector) {
      $(_tax_amount_selector).val(_tax_amount.toFixed(2));
    }
    if (_ex_tax_amount_selector) {
      return $(_ex_tax_amount_selector).val(_ex_tax_amount.toFixed(2));
    }
  };

  AlphaOMSUtils.prototype.on_keyup_search = function(event) {
    var $elem, $updates_elem, _search_term, _updates_elem_id, _url, form_data;
    $elem = $(event.target);
    _url = $elem.data("search");
    _updates_elem_id = $elem.data("search-update");
    $updates_elem = $("" + _updates_elem_id);
    _search_term = $elem.val();
    form_data = $elem.serialize();
    return $.ajax({
      url: "" + _url + (get_url_separator(_url)) + form_data,
      dataType: "html"
    }).success(function(html) {
      if ($updates_elem.get(0).outerHTML !== html) {
        return $updates_elem.replaceWith(html);
      }
    }).error(function() {
      return alert("There was an error");
    }).done(function() {
      return hide_spinner();
    });
  };

  AlphaOMSUtils.prototype.on_form_submit_turn_off_disabled = function(event) {
    var $form;
    event.preventDefault();
    $form = $(event.target).closest("form[data-on-submit-turn-off-disabled]");
    $form.find("input[data-on-submit-turn-off-disabled='true']").prop("disabled", false);
    return $form.submit();
  };

  AlphaOMSUtils.prototype.disable_form = function() {
    var $form;
    $form = $("form[data-form-disabled='true']");
    $form.find("input, select, textarea").prop("disabled", "disabled");
    return this.disable_switches($form);
  };

  AlphaOMSUtils.prototype.submit_nested_embedded_form = function(event) {
    var $form;
    event.preventDefault();
    $form = $(event.target).closest("form[data-nested-embedded-form]");
    return $form.submit();
  };

  AlphaOMSUtils.prototype.on_click_row_submit = function(event) {
    var $buttons, $row, $url, ajax_method, form_data;
    event.preventDefault();
    $url = $(event.target).data("on-click-row-submit");
    $row = $(event.target).closest("tr");
    $buttons = $row.find("[data-on-click-row-submit-button-disable]");
    ajax_method = "put";
    form_data = $row.find("input, select, textarea");
    $buttons.prop("disabled", true);
    return $.ajax({
      type: ajax_method,
      url: $url,
      data: form_data.serialize(),
      dataType: "script"
    }).done(function() {}, $('#spinner, #spinner_nav').hide());
  };

  AlphaOMSUtils.prototype.on_keyup_auto_save = function(form_id) {
    var $form, _black_list_params, _form_id, _time_diff, _time_now, _white_list_params;
    _time_now = Date.now();
    _time_diff = _time_now - this.last_autosave_timestamp;
    $form = $(form_id);
    _form_id = $form.attr("id");
    _white_list_params = [];
    _black_list_params = [];
    if (_time_diff > 1500) {
      this.last_autosave_timestamp = _time_now;
      this.submit_form(_form_id, _white_list_params, _black_list_params);
    }
    if (this.final_autosave_timeout) {
      clearTimeout(this.final_autosave_timeout);
    }
    return this.final_autosave_timeout = setTimeout((function(_this) {
      return function() {
        return _this.submit_form(_form_id, _white_list_params, _black_list_params);
      };
    })(this), 1500);
  };

  AlphaOMSUtils.prototype.on_change_auto_save = function(event) {
    var form;
    form = $(event.target).closest("form");
    return $.ajax({
      type: "post",
      url: form.attr('action'),
      data: form.serialize(),
      dataType: "script"
    });
  };

  AlphaOMSUtils.prototype.on_input_data_mass_assignment = function(event) {
    var $elem, _parts, _selector;
    $elem = $(event.target);
    _selector = $elem.data("mass-assignment");
    if (typeof $elem.is === "function" ? $elem.is("input") : void 0) {
      return $(_selector + ":enabled").val($elem.val()).change();
    } else if (typeof $elem.is === "function" ? $elem.is("select") : void 0) {
      _parts = /(\di)/.exec($elem.attr("name"));
      if (_parts !== null) {
        return $(_selector + "[name*='" + _parts[0] + "']:enabled").val($elem.val()).change();
      } else {
        return $(_selector + ":enabled").val($elem.val()).change();
      }
    }
  };

  AlphaOMSUtils.prototype.monitor_background_progress_tasks = function() {
    return $("[data-background-processing-task]").each((function(_this) {
      return function(i, elem) {
        var $backround_task_elem, _complete_ajax_get_url, _complete_visit_url, _interval, _monitor_url;
        $backround_task_elem = $(elem);
        _monitor_url = $backround_task_elem.data("background-processing-task-monitor-url");
        _complete_visit_url = $backround_task_elem.data("background-processing-task-on-complete-visit-url");
        _complete_ajax_get_url = $backround_task_elem.data("background-processing-task-on-complete-ajax-get-url");
        $(".bar").css('background', 'green').css('display', 'block').css('width', '0%').text("Processing...");
        return _interval = setInterval(function() {
          return $.ajax({
            url: _monitor_url,
            dataType: "json"
          }).success(function(data) {
            var success_callback;
            $(elem).find(".bar").css('background', 'green').css('display', 'block').css('width', data.percent_processed + "%");
            if (data.complete) {
              $(elem).find(".bar").text("Complete");
              clearInterval(_interval);
              if (_complete_visit_url) {
                return Turbo.visit(_complete_visit_url + ("?background_processing_task_id=" + ($backround_task_elem.data("background-processing-task"))));
              } else if (_complete_ajax_get_url) {
                success_callback = function(response) {};
                return $.get(_complete_ajax_get_url, {}, success_callback).fail(function() {
                  return alert("There was an error loading the resource");
                });
              }
            }
          }).error(function() {
            clearInterval(_interval);
            return console.log("There was an error");
          });
        }, 1000);
      };
    })(this));
  };

  AlphaOMSUtils.prototype.on_click_submit_form = function(event) {
    var $elem, _form_id;
    $elem = $(event.target).closest("[data-on-click-submit-form]");
    _form_id = $elem.data("on-click-submit-form");
    return $(_form_id).submit();
  };

  AlphaOMSUtils.prototype.open_bs2_modal = function(html, wide) {
    if (wide == null) {
      wide = false;
    }
    $('#modal').modal('hide').empty().removeClass("wide").append(html).toggleClass("wide", wide).modal('show');
    return $('#spinner, #spinner_nav').hide();
  };

  AlphaOMSUtils.prototype.close_bs2_modal = function() {
    $('#modal').modal('hide').empty();
    return $('#spinner, #spinner_nav').hide();
  };

  AlphaOMSUtils.prototype.open_bs5_modal = function(html, extra_classes) {
    var heading, modal_elem, ref, was_shown;
    if (extra_classes == null) {
      extra_classes = "";
    }
    modal_elem = document.getElementById("modal");
    was_shown = modal_elem.classList.contains("show");
    modal_elem.className = ("modal fade " + extra_classes).trim();
    if (was_shown) {
      modal_elem.classList.add("show");
    }
    $(modal_elem).html(html);
    modal_elem.removeAttribute("aria-labelledby");
    modal_elem.removeAttribute("aria-label");
    heading = (ref = modal_elem.querySelector(".modal-header")) != null ? ref.querySelector(".modal-title, h1, h2, h3, h4, h5, h6") : void 0;
    if (heading) {
      if (!heading.id) {
        heading.id = "shared-modal-title";
      }
      modal_elem.setAttribute("aria-labelledby", heading.id);
    }
    window.bootstrap.Modal.getOrCreateInstance(modal_elem).show();
    return $('#spinner, #spinner_nav').hide();
  };

  AlphaOMSUtils.prototype.close_modal = function() {
    var _instance, modal_elem;
    modal_elem = document.getElementById("modal");
    if (modal_elem) {
      _instance = window.bootstrap.Modal.getInstance(modal_elem);
      if ((_instance != null ? _instance._isShown : void 0) && _instance._isTransitioning) {
        $(modal_elem).one("shown.bs.modal", function() {
          return _instance.hide();
        });
      } else {
        if (_instance != null) {
          _instance.hide();
        }
      }
    }
    return $('#spinner, #spinner_nav').hide();
  };

  AlphaOMSUtils.prototype.scroll_to_first_error = function() {
    var _element;
    _element = $(".has-error, .is-invalid").first();
    if (_element.length > 0) {
      return $([document.documentElement, document.body]).animate({
        scrollTop: _element.offset().top
      }, 300);
    }
  };

  AlphaOMSUtils.prototype.scroll_to_element = function(selector, speed) {
    var _element;
    if (speed == null) {
      speed = 300;
    }
    _element = $(selector).first();
    if (_element.length > 0) {
      return $([document.documentElement, document.body]).animate({
        scrollTop: _element.offset().top
      }, speed);
    }
  };

  AlphaOMSUtils.prototype.scroll_when_position_settles = function(target, duration, stable_frames_needed) {
    var check, last_top, stable_frames;
    if (duration == null) {
      duration = 300;
    }
    if (stable_frames_needed == null) {
      stable_frames_needed = 4;
    }
    last_top = null;
    stable_frames = 0;
    check = function() {
      var top;
      top = target.offset().top;
      if (last_top !== null && Math.abs(top - last_top) < 1) {
        stable_frames += 1;
      } else {
        stable_frames = 0;
      }
      last_top = top;
      if (stable_frames >= stable_frames_needed) {
        return $([document.documentElement, document.body]).animate({
          scrollTop: top
        }, duration);
      } else {
        return requestAnimationFrame(check);
      }
    };
    return requestAnimationFrame(check);
  };

  get_url_separator = function(url) {
    if (/\?/.test(url)) {
      return "&";
    } else {
      return "?";
    }
  };

  AlphaOMSUtils.prototype.append_params = function(url, params) {
    if (!(params.length > 0)) {
      return url;
    }
    return url + get_url_separator(url) + params;
  };

  AlphaOMSUtils.prototype.serialize_nested_object_for_url_params = function(obj, prefix) {
    var item, j, key, len, nested_key, queryString, value;
    if (prefix == null) {
      prefix = null;
    }
    queryString = [];
    for (key in obj) {
      value = obj[key];
      if (prefix) {
        nested_key = prefix + "[" + key + "]";
      } else {
        nested_key = key;
      }
      if (value === null) {
        queryString.push((encodeURIComponent(nested_key)) + "=");
      } else if (typeof value === "object" && !Array.isArray(value)) {
        if (Object.keys(value).length === 0) {
          queryString.push((encodeURIComponent(nested_key)) + "=");
        } else {
          queryString.push(this.serialize_nested_object_for_url_params(value, nested_key));
        }
      } else if (Array.isArray(value)) {
        for (j = 0, len = value.length; j < len; j++) {
          item = value[j];
          if (typeof item === "object") {
            queryString.push(this.serialize_nested_object_for_url_params(item, nested_key + "[]"));
          } else {
            queryString.push((encodeURIComponent(nested_key)) + "[]=" + (encodeURIComponent(item)));
          }
        }
      } else {
        queryString.push((encodeURIComponent(nested_key)) + "=" + (encodeURIComponent(value)));
      }
    }
    return queryString.join("&");
  };

  visit = function(url, params_string) {
    if (params_string == null) {
      params_string = "";
    }
    return Turbo.visit("" + url + (get_url_separator(url)) + params_string);
  };

  AlphaOMSUtils.prototype.show_spinner = function(selector, top_offset, left_offset) {
    var _data_left, _data_top, _left_offset, _top_offset, element, position, top;
    if (top_offset == null) {
      top_offset = 0;
    }
    if (left_offset == null) {
      left_offset = 0;
    }
    _top_offset = top_offset;
    _left_offset = left_offset;
    element = $(selector);
    if (element) {
      position = element.offset();
      top = position.top;
      _data_left = element.data("spinner-left");
      if (_data_left) {
        _left_offset = parseInt(_data_left);
      }
      _data_top = element.data("spinner-top");
      if (_data_top) {
        _top_offset = parseInt(_data_top);
      }
      if (position) {
        return $('#spinner').css({
          top: position.top + _top_offset,
          left: position.left + element.width() + _left_offset,
          'z-index': 1100
        }).show();
      }
    }
  };

  AlphaOMSUtils.prototype.twilio_message_calc = function(event) {
    var $cost_per_message_target, $elem, $num_characters_target, $total_cost_target, _cost_per_message, _message_cost_by_segments, _num_characters, _segment_count, _target_count, _text, _total_cost, _twilio_segmented_message;
    $elem = $(event.target);
    $num_characters_target = $("[data-twilio-num-characters='true']");
    $cost_per_message_target = $("[data-twilio-cost-per-message='true']");
    $total_cost_target = $("[data-twilio-total-cost='true']");
    _target_count = $elem.data("twilio-message-target-count");
    _cost_per_message = Number($elem.data("twilio-message-cost-per-message"));
    _text = $elem.val();
    _num_characters = _text.length;
    _twilio_segmented_message = new SegmentedMessage(_text);
    _segment_count = _twilio_segmented_message.segmentsCount;
    _message_cost_by_segments = _segment_count * _cost_per_message;
    _total_cost = _target_count * _message_cost_by_segments;
    $num_characters_target.html(_num_characters);
    $cost_per_message_target.html(_message_cost_by_segments);
    $total_cost_target.html(_total_cost);
    if (_segment_count > 4) {
      $("#twilio_too_many_segments_error").show();
      return $("#submit_message_button").hide();
    } else {
      $("#submit_message_button").show();
      return $("#twilio_too_many_segments_error").hide();
    }
  };

  AlphaOMSUtils.prototype.countdown_timer = function() {
    var $days, $elem, $hours, $mins, $seconds, _countdown_interval, _cut_off_datetime, _datetime, _has_days, _has_hours, _has_mins, _has_seconds, _warning_minutes;
    $elem = $("[data-countdown-timer]");
    _datetime = $elem.attr("data-countdown-timer");
    _warning_minutes = $elem.attr("data-countdown-warning-minutes");
    if (_warning_minutes) {
      _warning_minutes = parseInt(_warning_minutes);
    }
    _cut_off_datetime = new Date(_datetime).getTime();
    $days = $elem.find("[data-countdown-days]");
    $hours = $elem.find("[data-countdown-hours]");
    $mins = $elem.find("[data-countdown-mins]");
    $seconds = $elem.find("[data-countdown-seconds]");
    _has_days = $days.length > 0;
    _has_hours = $hours.length > 0;
    _has_mins = $mins.length > 0;
    _has_seconds = $seconds.length > 0;
    this.render_countdown_time(_cut_off_datetime, $elem, $days, _has_days, $hours, _has_hours, $mins, _has_mins, $seconds, _has_seconds, _warning_minutes);
    return _countdown_interval = setInterval((function(_this) {
      return function() {
        var _distance;
        _distance = _this.render_countdown_time(_cut_off_datetime, $elem, $days, _has_days, $hours, _has_hours, $mins, _has_mins, $seconds, _has_seconds, _warning_minutes);
        if (_distance < 0) {
          clearInterval(_countdown_interval);
          return $elem.empty();
        }
      };
    })(this), 1000);
  };

  AlphaOMSUtils.prototype.render_countdown_time = function(cut_off_time, container_elem, days_elem, has_days, hours_elem, has_hours, mins_elem, has_mins, seconds_elem, has_seconds, warning_minutes) {
    var _days, _distance, _hours, _mins, _seconds, _time_now, _warning_distance;
    _time_now = new Date().getTime();
    _distance = cut_off_time - _time_now;
    if (_distance < 0) {
      return;
    }
    _days = Math.floor(_distance / (1000 * 60 * 60 * 24));
    _hours = Math.floor((_distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    _mins = Math.floor((_distance % (1000 * 60 * 60)) / (1000 * 60));
    _seconds = Math.floor((_distance % (1000 * 60)) / 1000);
    if (warning_minutes) {
      _warning_distance = warning_minutes * 60 * 1000;
      if (_distance < _warning_distance) {
        container_elem.removeClass("countdown_timer_warning").addClass("countdown_timer_warning");
      }
    }
    if (has_days) {
      days_elem.text(_days + " days");
    }
    if (has_hours) {
      if (_hours === 0) {
        hours_elem.text("");
      } else {
        hours_elem.text(_hours + "h ");
      }
    }
    if (has_mins) {
      mins_elem.text(_mins + "m ");
    }
    if (has_seconds) {
      if (_seconds < 10) {
        seconds_elem.text("0" + _seconds + "s");
      } else {
        seconds_elem.text(_seconds + "s");
      }
    }
    return _distance;
  };

  AlphaOMSUtils.prototype.debounce = function(func, timeout) {
    var timer;
    if (timeout == null) {
      timeout = 300;
    }
    timer = null;
    return function() {
      var args;
      console.log("inside debounce");
      clearTimeout(timer);
      args = Array.prototype.slice.call(arguments);
      return timer = setTimeout(function() {
        return func.apply(this, args);
      }, timeout);
    };
  };

  return AlphaOMSUtils;

})();

window.alpha_oms_utils = new AlphaOMSUtils();

$(document).on("change", ".select_link", (function(_this) {
  return function(event) {
    return _this.alpha_oms_utils.clicked_on_select_link(event);
  };
})(this));

$(document).on('click', '[data-at-link]', (function(_this) {
  return function(event) {
    return _this.alpha_oms_utils.clicked_on_data_link(event);
  };
})(this));

$(document).on('click', '[data-at-link-remote]', (function(_this) {
  return function(e) {
    return _this.alpha_oms_utils.clicked_on_data_link_remote(event);
  };
})(this));

$(document).on('switchChange.bootstrapSwitch', '[data-switch-show-fields]', (function(_this) {
  return function(event, state) {
    return _this.alpha_oms_utils.switch_show_fields(event, state);
  };
})(this));

$(document).on('switchChange.bootstrapSwitch', '[data-switch-hide-fields]', (function(_this) {
  return function(event, state) {
    return _this.alpha_oms_utils.switch_hide_fields(event, state);
  };
})(this));

$(document).on('switchChange.bootstrapSwitch', '[data-hide-fields-when-on]', (function(_this) {
  return function(event, state) {
    return _this.alpha_oms_utils.hide_fields_when_on(event, state);
  };
})(this));

$(document).on('switchChange.bootstrapSwitch', '[data-show-fields-when-on]', (function(_this) {
  return function(event, state) {
    return _this.alpha_oms_utils.show_fields_when_on(event, state);
  };
})(this));

$(document).on('switchChange.bootstrapSwitch', '[data-switch-secondary-show-field-parent]', (function(_this) {
  return function(event, state) {
    return _this.alpha_oms_utils.switch_secondary_show_field(event, state);
  };
})(this));

$(document).on('switchChange.bootstrapSwitch', '[data-on-change-form-rehydrate]', (function(_this) {
  return function(event) {
    return _this.alpha_oms_utils.on_change_form_rehydrate(event);
  };
})(this));

$(document).on('change', '[data-on-change-form-rehydrate]', (function(_this) {
  return function(event) {
    return _this.alpha_oms_utils.on_change_form_rehydrate(event);
  };
})(this));

$(document).on("click", '[data-on-click-form-rehydrate]', (function(_this) {
  return function(event) {
    event.preventDefault();
    return _this.alpha_oms_utils.on_change_form_rehydrate(event);
  };
})(this));

$(document).on("click", '[data-on-click-submit-to]', (function(_this) {
  return function(event) {
    event.preventDefault();
    return _this.alpha_oms_utils.on_click_submit_to(event);
  };
})(this));

$(document).on('change', '[data-checkbox-show-fields]', (function(_this) {
  return function(event, state) {
    return _this.alpha_oms_utils.checkbox_show_fields(event, state);
  };
})(this));

$(document).on('change', '[data-checkbox-hide-fields]', (function(_this) {
  return function(event, state) {
    return _this.alpha_oms_utils.checkbox_hide_fields(event, state);
  };
})(this));

$(document).on('change', '[data-checkbox-toggle-all]', (function(_this) {
  return function(event) {
    return _this.alpha_oms_utils.toggle_all_check_boxes(event);
  };
})(this));

$(document).on('change', '[data-select-option-show-fields]', (function(_this) {
  return function(event, state) {
    return _this.alpha_oms_utils.select_option_show_fields(event, state);
  };
})(this));

$(document).on('change', '[data-on-change-submit-partial]', (function(_this) {
  return function(event) {
    return _this.alpha_oms_utils.on_change_submit_partial(event);
  };
})(this));

$(document).on('change', '[data-on-change-form-partial]', (function(_this) {
  return function(event) {
    return _this.alpha_oms_utils.on_change_form_partial(event);
  };
})(this));

$(document).on('change', '[data-on-change-get-url]', (function(_this) {
  return function(event) {
    return _this.alpha_oms_utils.on_change_get_url(event);
  };
})(this));

$(document).on('change', '[data-on-change-opacity]', (function(_this) {
  return function(event) {
    return _this.alpha_oms_utils.on_change_opacity(event);
  };
})(this));

$(document).on('change', '[data-on-change-set-target-value]', (function(_this) {
  return function(event) {
    return _this.alpha_oms_utils.on_change_set_target_value(event);
  };
})(this));

$(document).on('click', '[data-at-radio-buttons] label', (function(_this) {
  return function(event) {
    return _this.alpha_oms_utils.radio_buttons_change(event);
  };
})(this));

$(document).on('click', '[data-at-swatch]', (function(_this) {
  return function(event) {
    return _this.alpha_oms_utils.on_click_swatch(event);
  };
})(this));

$(document).on("click", "ul[data-tab-update] li[data-tab] a", (function(_this) {
  return function(event) {
    return _this.alpha_oms_utils.on_tab_select(event);
  };
})(this));

$(document).on("click", "[data-on-click-remove]", (function(_this) {
  return function(event) {
    return _this.alpha_oms_utils.on_click_remove(event);
  };
})(this));

$(document).on("click", "[data-on-click-empty]", (function(_this) {
  return function(event) {
    return _this.alpha_oms_utils.on_click_empty(event);
  };
})(this));

$(document).on("click", "[data-on-click-clear-input]", (function(_this) {
  return function(event) {
    return _this.alpha_oms_utils.on_click_clear_input(event);
  };
})(this));

$(document).on("click", "[data-on-click-set-input]", (function(_this) {
  return function(event) {
    return _this.alpha_oms_utils.on_click_set_input(event);
  };
})(this));

$(document).on("click", "[data-on-click-show]", (function(_this) {
  return function(event) {
    return _this.alpha_oms_utils.on_click_show(event);
  };
})(this));

$(document).on("click", "[data-on-click-toggle-input]", (function(_this) {
  return function(event) {
    return _this.alpha_oms_utils.on_click_toggle_input(event);
  };
})(this));

$(document).on("click", "[data-on-click-prevent-default]", (function(_this) {
  return function(event) {
    return _this.alpha_oms_utils.on_click_prevent_default(event);
  };
})(this));

$(document).on("click", "[data-on-click-toggle-visibility]", (function(_this) {
  return function(event) {
    return _this.alpha_oms_utils.on_click_toggle(event);
  };
})(this));

$(document).on("click", "[data-on-click-toggle-disabled]", (function(_this) {
  return function(event) {
    return _this.alpha_oms_utils.on_click_toggle_disable(event);
  };
})(this));

$(document).on("click", "[data-on-click-hide]", (function(_this) {
  return function(event) {
    return _this.alpha_oms_utils.on_click_hide(event);
  };
})(this));

$(document).on("click", "[data-on-click-text]", (function(_this) {
  return function(event) {
    return _this.alpha_oms_utils.on_click_text(event);
  };
})(this));

$(document).on("click", "[data-on-click-enable]", (function(_this) {
  return function(event) {
    return _this.alpha_oms_utils.on_click_enable(event);
  };
})(this));

$(document).on("click", "[data-on-click-disable]", (function(_this) {
  return function(event) {
    return _this.alpha_oms_utils.on_click_disable(event);
  };
})(this));

$(document).on("click", "[data-on-click-close-bs2-modal]", (function(_this) {
  return function(event) {
    return _this.alpha_oms_utils.on_click_close_bs2_modal(event);
  };
})(this));

$(document).on("click", "[data-on-click-copy]", (function(_this) {
  return function(event) {
    return _this.alpha_oms_utils.on_click_copy(event);
  };
})(this));

$(document).on("click", "[data-on-click-scroll-to]", (function(_this) {
  return function(event) {
    return _this.alpha_oms_utils.on_click_scroll_to(event);
  };
})(this));

$(document).on("click", "[data-cancel-button]", (function(_this) {
  return function(event) {
    return event.preventDefault();
  };
})(this));

$(document).on("keyup", "[data-search]", (function(_this) {
  return function(event) {
    return _this.alpha_oms_utils.on_keyup_search(event);
  };
})(this));

$(document).on("keyup", "td.unit_cost input, td.tax_rate input, td.qty input", (function(_this) {
  return function(event) {
    return _this.alpha_oms_utils.recalculate_invoice_item_costs(event);
  };
})(this));

$(document).on("keyup", "[data-total-up-inputs]", (function(_this) {
  return function(event) {
    return _this.alpha_oms_utils.on_keyup_total_up_inputs(event);
  };
})(this));

$(document).on("keyup", "[data-auto-save]", (function(_this) {
  return function(event) {
    return _this.alpha_oms_utils.on_keyup_auto_save(event);
  };
})(this));

$(document).on("change", "[data-auto-save]", (function(_this) {
  return function(event) {
    return _this.alpha_oms_utils.on_change_auto_save(event);
  };
})(this));

$(document).on('switchChange.bootstrapSwitch', '[data-auto-save]', (function(_this) {
  return function(event) {
    return _this.alpha_oms_utils.on_change_auto_save(event);
  };
})(this));

$(document).on("click", "[data-sum-table-checkbox]", (function(_this) {
  return function(event) {
    return _this.alpha_oms_utils.on_click_sum_table_checkbox(event);
  };
})(this));

$(document).on("keyup", "[data-calculate-tax]", (function(_this) {
  return function(event) {
    return _this.alpha_oms_utils.on_keyup_calculate_tax(event);
  };
})(this));

$(document).on("click", "[data-checkbox-checked-submit-url]", (function(_this) {
  return function(event) {
    return _this.alpha_oms_utils.on_click_checkbox_checked_submit(event);
  };
})(this));

$(document).on("click", "[data-checkbox-unchecked-submit-url]", (function(_this) {
  return function(event) {
    return _this.alpha_oms_utils.on_click_checkbox_unchecked_submit(event);
  };
})(this));

$(document).on("click", "tr[data-row-select-trigger-checkbox] td", (function(_this) {
  return function(event) {
    return _this.alpha_oms_utils.on_click_row_select_trigger_checkbox(event);
  };
})(this));

$(document).on("click", "[data-radio-button-container]", (function(_this) {
  return function(event) {
    return _this.alpha_oms_utils.clicked_radio_button_container(event);
  };
})(this));

$(document).on("click", "table[data-row-select] input[type='checkbox'][data-row-select-checkbox]", (function(_this) {
  return function(event) {
    return _this.alpha_oms_utils.on_click_row_select_checkbox(event);
  };
})(this));

$(document).on("switchChange.bootstrapSwitch", "table[data-row-select] input[type='checkbox'][data-row-select-checkbox]", (function(_this) {
  return function(event) {
    return _this.alpha_oms_utils.on_click_row_select_checkbox(event);
  };
})(this));

$(document).on("click", "form[data-on-submit-turn-off-disabled] [type='submit']", (function(_this) {
  return function(event) {
    return _this.alpha_oms_utils.on_form_submit_turn_off_disabled(event);
  };
})(this));

$(document).on("input", "[data-twilio-message-calculator-input='true']", (function(_this) {
  return function(event) {
    return _this.alpha_oms_utils.twilio_message_calc(event);
  };
})(this));

$(document).on("input", "[data-mass-assignment]", (function(_this) {
  return function(event) {
    return _this.alpha_oms_utils.on_input_data_mass_assignment(event);
  };
})(this));

$(document).on("click", "[data-on-click-submit-form]", (function(_this) {
  return function(event) {
    return _this.alpha_oms_utils.on_click_submit_form(event);
  };
})(this));

$(document).on("turbo:load", (function(_this) {
  return function(event) {
    if ($("[data-form-disabled='true']").length > 0) {
      return _this.alpha_oms_utils.disable_form();
    }
  };
})(this));

$(document).on("turbo:load", (function(_this) {
  return function(event) {
    if ($("[data-countdown-timer]").length > 0) {
      return _this.alpha_oms_utils.countdown_timer();
    }
  };
})(this));

$(document).on("click", "form[data-nested-embedded-form] input[type='submit'],form[data-nested-embedded-form] button[type='submit']", (function(_this) {
  return function(event) {
    return _this.alpha_oms_utils.submit_nested_embedded_form(event);
  };
})(this));

$(document).on("click", "tr a[data-on-click-row-submit]", (function(_this) {
  return function(event) {
    return _this.alpha_oms_utils.on_click_row_submit(event);
  };
})(this));

$(document).on("click", '[data-on-click-show-loading]', (function(_this) {
  return function(e) {
    return _this.alpha_oms_utils.on_click_show_loading(e);
  };
})(this));

$(document).on("click", '[data-on-click-clear-loading]', (function(_this) {
  return function(e) {
    return _this.alpha_oms_utils.on_click_clear_loading(e);
  };
})(this));

$(document).on("click", "[data-popover-remote]", (function(_this) {
  return function(e) {
    return _this.alpha_oms_utils.on_click_popover_remote(e);
  };
})(this));

$(document).on('click', (function(_this) {
  return function(e) {
    return _this.alpha_oms_utils.close_popover_remotes(e);
  };
})(this));

$(document).on("turbo:load", (function(_this) {
  return function(event) {
    return $('[data-at-nf-initial-view="edit"]').find('a.edit_nested_fields').trigger("click");
  };
})(this));

$(document).on('ajax:success', '#modal form', function() {
  $('#modal').animate({
    scrollTop: 0
  }, 'fast');
  return $('#spinner, #spinner_nav').hide();
});

}).call(window);
